import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';
import { AuthTokenInterceptor } from './auth-token.interceptor';
import { ErrorInterceptor } from './error.interceptor';

/**
 * El orden importa: AuthTokenInterceptor va al final para quedar por dentro de
 * ErrorInterceptor. Así el 403 que se recupera reemitiendo el token nunca llega
 * al manejo de errores y ErrorInterceptor solo ve el resultado final de la
 * petición (la respuesta del reintento, o el error definitivo).
 */
export const httpInterceptorProviders = [
	{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
];
